import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createRoleSlice = createAsyncThunk(
  "role/createRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/role/createRole", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getRoleSlice = createAsyncThunk(
  "role/getAllRoles",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post("/role/getAllRoles", serchingFor, {
        headers: {
          "Content-Type": "application/json",
          token: serchingFor.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getRoleById = createAsyncThunk(
  "role/getRoleById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/role/getRoleById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateRoleSlice = createAsyncThunk(
  "role/updateRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/role/updateRole",
        {
          roleDetails: data,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteRoleSlice = createAsyncThunk(
  "role/deleteRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/role/deleteRole", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllModulesWithPermissionSlice = createAsyncThunk(
  "/role/getAllClinicModulesWithPermission",
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/role/getAllClinicModulesWithPermission",
        roleId,
        {
          headers: {
            "Content-Type": "application/json",
            token: roleId.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateParentPermissions = createAsyncThunk(
  "/role/updateParentPermission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/role/updateParentPermission", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

export const updateChildPermissions = createAsyncThunk(
  "/role/updateChildPermission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/role/updateChildPermission", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

export const updateSubChildPermissions = createAsyncThunk(
  "/role/updateSubChildPermission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/role/updateSubChildPermission", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  roles: [],
  rolePermissions: [],
  roleInFo: [],
  moduleRolePermissions: [],
  loading: false,
  createSuccessMessage: null,
  createErrorMessage: null,
  updateSuccessMessage: null,
  updateErrorMessage: null,
  deleteSuccessMessage: null,
  deleteErrorMessage: null,
  parentPermissionUpdateSuccessMessage: null,
  parentPermissionUpdateErrorMessage: null,
  childPermissionUpdateSuccessMessage: null,
  childPermissionUpdateErrorMessage: null,
  subChildPermissionUpdateSuccessMessage: null,
  subChildPermissionUpdateErrorMessage: null,
  searchMessage: null,
  currentPage: 1,
  totalPages: null,
  totalCount: 0,
  hasMore: true,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createSuccessMessage = null;
      state.createErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateSuccessMessage = null;
      state.updateErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteSuccessMessage = null;
      state.deleteErrorMessage = null;
    },
    resermoduleRolePermissionMessages: (state) => {
      state.moduleRolePermissionupdateSuccessMessage = null;
      state.moduleRolePermissionupdateErrorMessage = null;
    },
    resetParentmodulePermissionMessages: (state) => {
      state.parentPermissionUpdateSuccessMessage = null;
      state.parentPermissionUpdateErrorMessage = null;
    },
    resetChildmodulePermissionMessages: (state) => {
      state.childPermissionUpdateSuccessMessage = null;
      state.childPermissionUpdateErrorMessage = null;
    },
    resetSubChildmodulePermissionMessages: (state) => {
      state.subChildPermissionUpdateSuccessMessage = null;
      state.subChildPermissionUpdateErrorMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createRoleSlice.pending, (state) => {
        state.loading = true;
        state.createSuccessMessage = null;
        state.createErrorMessage = null;
      })
      .addCase(createRoleSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createErrorMessage = action.payload.result.message;
        } else {
          state.createSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createRoleSlice.rejected, (state, action) => {
        state.loading = false;
        state.createErrorMessage = action.payload.result.message;
      })
      .addCase(getRoleSlice.pending, (state) => {
        state.loading = true;
        state.createSuccessMessage = null;
        state.createErrorMessage = null;
      })
      .addCase(getRoleSlice.fulfilled, (state, action) => {
        state.loading = false;
        
        // Check for success false (Logic from Client Type Slice)
        if (!action.payload.success) {
          state.roles = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage = action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        // Logic: Always replace roles list based on the current page (same as Client Type)
        state.roles = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0; 
        state.hasMore = result.hasMore;
        state.searchMessage = null;
      })
      .addCase(getRoleSlice.rejected, (state, action) => {
        state.loading = false;
        state.createErrorMessage = action.payload.result?.message;
      })
      .addCase(getAllModulesWithPermissionSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllModulesWithPermissionSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.moduleRolePermissions = action.payload.result.list;
        } else {
          state.moduleRolePermissions = [];
          state.errorMessage = action.payload.result.message;
        }
      })
      .addCase(getAllModulesWithPermissionSlice.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(updateRoleSlice.pending, (state) => {
        state.loading = true;
        state.updateSuccessMessage = null;
        state.updateErrorMessage = null;
      })
      .addCase(updateRoleSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateErrorMessage = action.payload.result.message;
        } else {
          state.updateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateRoleSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateErrorMessage = action.payload.result.message;
      })
      .addCase(deleteRoleSlice.pending, (state) => {
        state.loading = true;
        state.deleteSuccessMessage = null;
        state.deleteErrorMessage = null;
      })
      .addCase(deleteRoleSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteErrorMessage = action.payload.result.message;
        } else {
          state.deleteSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteRoleSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteErrorMessage = action.payload.result.message;
      })
      .addCase(getRoleById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRoleById.fulfilled, (state, action) => {
        state.loading = false;
        state.roleInFo = action.payload.result.list;
      })
      .addCase(getRoleById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateParentPermissions.pending, (state) => {
        state.loading = true;
        state.parentPermissionUpdateSuccessMessage = null;
        state.parentPermissionUpdateErrorMessage = null;
      })
      .addCase(updateParentPermissions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.parentPermissionUpdateSuccessMessage =
            action.payload.result.message;
        } else {
          state.parentPermissionUpdateErrorMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateParentPermissions.rejected, (state, action) => {
        state.loading = false;
        state.parentPermissionUpdateErrorMessage =
          action.payload.result.message;
      })
      .addCase(updateChildPermissions.pending, (state) => {
        state.loading = true;
        state.childPermissionUpdateSuccessMessage = null;
      })
      .addCase(updateChildPermissions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.childPermissionUpdateSuccessMessage =
            action.payload.result.message;
        } else {
          state.childPermissionUpdateErrorMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateChildPermissions.rejected, (state, action) => {
        state.loading = false;
        state.childPermissionUpdateErrorMessage = action.payload.result.message;
      })
      .addCase(updateSubChildPermissions.pending, (state) => {
        state.loading = true;
        state.subChildPermissionUpdateSuccessMessage = null;
        state.subChildPermissionUpdateErrorMessage = null;
      })
      .addCase(updateSubChildPermissions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.subChildPermissionUpdateSuccessMessage =
            action.payload.result.message;
        } else {
          state.subChildPermissionUpdateErrorMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateSubChildPermissions.rejected, (state, action) => {
        state.loading = false;
        state.subChildPermissionUpdateErrorMessage =
          action.payload.result.message;
      });
  },
});

export const {
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
  resetParentPermissionsMessages,
  resetChildPermissionsMessages,
  resetSupperChildPermissionsMessages,
  resermoduleRolePermissionMessages,
} = roleSlice.actions;
export default roleSlice.reducer;